import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {ModalforgotpasswordComponent} from '../modalforgotpassword/modalforgotpassword.component'
import * as firebase from 'firebase'
import { Router } from '@angular/router';
import { Subject } from 'rxjs'
import { GuardServiceGuard } from '../guard-service.guard'

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  loginerror=false;
  autenticando=false;
  email;
  password;
  token='';
  mensajeError='';

  alertaActiva=false;
  mensajeAlerta='';
  tipodeAlerta='primary';

  constructor(private router:Router, private modalService: NgbModal, private guardServiceGuard:GuardServiceGuard) { }

  ngOnInit(): void {
    this.loginerror=false;
    this.autenticando=false;
    this.token='';
    this.logout()
  }
  logout() {
    firebase.auth().signOut();
    this.guardServiceGuard.token=null;
    this.router.navigateByUrl('/home');
  }

  openModalForgotpassword(){
    const modalRef = this.modalService.open(ModalforgotpasswordComponent);
    modalRef.componentInstance.name = 'World';
  }

  login() {

    // this.presentLoading("Validando...")
    this.autenticando=true
    this.loginerror=false
      
      firebase.auth().signInWithEmailAndPassword(this.email , this.password).then((data) => {


      this.revisarsiesadmin(data.user.uid,(resCallback)=>{
        if(resCallback==true){
          this.revisarsiemailverificado((resCallback)=>{
            if(resCallback==true){

                    //  //SI ES ADMIN, SACAMOS EL TOKEN DE ID Y LO MANDAMOS AL SERVICIO DE GUARDIA DE RUTAS
                    //se saca el token y se le asigna a this.token arriba
                    firebase.auth().currentUser.getIdToken().then((resultadodeltoken) => {
                   
                      this.token = resultadodeltoken
                      //y lo mandamos al servicio de guardia de rutas
                      this.mandatoken(()=>{
                        this.guardServiceGuard.canActivate;
                        // this.loadingController.dismiss();
                        //y navegamos hacia el menu
                        this.router.navigateByUrl('/data-component');
                        
                        
                      })
                    }).catch((err) => {
                      this.autenticando=false;
                      this.alerta('danger',err)
                    })   
            }else
            if(resCallback==false){
              this.autenticando=false;
              this.alerta('danger',"No has activado tu cuenta de administrador")
            }
          })
        }else
        if(resCallback==false){
          // this.alertController.dismiss()

          this.autenticando=false;
          this.alerta('danger',"Acceso denegado. No tienes credenciales para ingresar a este módulo")
        }
          
        
      })


      
      
    }).catch((err) => {
      console.log(err);
      this.autenticando=false;
      this.alerta('danger',err)
    })
  }


  revisarsiesadmin(entrada,callback){
    var docRef = firebase.firestore().collection("autoridades").doc(entrada);
      docRef.get().then(function(doc) {
          if (doc.exists) {
              console.log("Document data:", doc.data());
              // this.ServiciodeperfildeusuarioService.admin = true
              callback(true);
          } else {
              // doc.data() will be undefined in this case
              console.log("No such document!");
              // this.ServiciodeperfildeusuarioService.admin = false 
              callback(false);
          }
      }).catch(function(error) {
          console.log("Error getting document:", error);
      });
  }

  mandatoken(callback) {
    this.guardServiceGuard.token = this.token
    callback(this.token);
  }

  revisarsiemailverificado(callback) {
    // if (firebase.auth().currentUser.emailVerified) { 
    //   callback(true);
    // } else {
    //   callback(false);
    // }
    callback(true);
  }

  alerta(tipo,input){
    this.alertaActiva=true;
    this.mensajeAlerta=input;
    this.tipodeAlerta=tipo;
  }

  closeAlert(){
    this.alertaActiva=false
  }




}
